import React, { useEffect } from 'react';

import { Link, Paper, styled, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import logo from 'assets/images/logos/finalcad-logo-text-dark.svg';
import Button from 'components/Button';
import ArrowRight from 'components/SvgComponents/icons/ArrowRight';
import globalMessages from 'translations/messages/global-messages';
import initialLoader from 'utils/initialLoader';

const Div_Wrapper = styled('div')(({ theme }) => ({
  background: theme.palette.background.primary,
  width: '100%',
  height: '100%',
  display: 'flex',
  color: theme.palette.text.dark,
  [theme.breakpoints.up('sm')]: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .invitation-expired-paper': {
    width: 420,
    height: 345,
    padding: theme.spacing(10, 7),
    zIndex: theme.zIndex.tooltip,
    boxShadow: 'none',
    backgroundColor: theme.palette.background.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '& .invitation-expired-logo': {
      width: 200,
    },
    '& .invitation-expired-title': {
      margin: 0,
    },
    '& .invitation-expired-content': {
      margin: 0,
    },
  },
}));

const InvitationExpiredPage = () => {
  const intl = useIntl();

  useEffect(() => {
    initialLoader.hideLoader();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage(globalMessages.link_no_longer_active)} |{' '}
          {intl.formatMessage(globalMessages.finalcad)}
        </title>
      </Helmet>
      <Div_Wrapper>
        <Paper className="invitation-expired-paper">
          <img className="invitation-expired-logo" src={logo} alt="Finalcad" />
          <Typography className="invitation-expired-title" component="h1" variant="h2">
            {intl.formatMessage(globalMessages.link_no_longer_active)}
          </Typography>
          <Typography className="invitation-expired-content" variant="body">
            {intl.formatMessage(globalMessages.link_contact_admin)}
          </Typography>
          <Button
            component={Link}
            href="https://www.finalcad.com"
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<ArrowRight />}
          >
            {intl.formatMessage(globalMessages.go_on_finalcad)}
          </Button>
        </Paper>
      </Div_Wrapper>
    </>
  );
};

export default InvitationExpiredPage;
